"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DropdownForm_1 = __importDefault(require("@App/kit/fields/v2/DropdownForm"));
const InputTextForm_1 = __importDefault(require("@App/kit/fields/v2/InputTextForm"));
const react_1 = __importDefault(require("react"));
const CheckboxForm_1 = __importDefault(require("@App/kit/fields/v2/CheckboxForm"));
const form_field_types_1 = require("@App/enum/form-field-types");
const form_field_1 = require("@App/forms/v2/common/form-field");
const DatePickerForm_1 = __importDefault(require("@App/kit/fields/v2/DatePickerForm"));
const MultiDropdownForm_1 = __importDefault(require("@Fields/MultiDropdownForm"));
const FormFieldFromProps = ({ field, isDisabled, validationDependency, children, }) => {
    const getFormFieldComponent = () => {
        if (field && (0, form_field_1.isFormFieldProp)(field)) {
            switch (field.type) {
                case form_field_types_1.FormFieldTypes.DROPDOWN:
                    return (react_1.default.createElement(DropdownForm_1.default, Object.assign({}, field, { validationDependency: validationDependency })));
                case form_field_types_1.FormFieldTypes.CHECKBOX:
                    return react_1.default.createElement(CheckboxForm_1.default, Object.assign({}, field), children);
                case form_field_types_1.FormFieldTypes.TEXT:
                    return (react_1.default.createElement(InputTextForm_1.default, Object.assign({}, field, { isDisabled: isDisabled, validationDependency: validationDependency })));
                case form_field_types_1.FormFieldTypes.DATEPICKER:
                    return react_1.default.createElement(DatePickerForm_1.default, Object.assign({}, field));
                case form_field_types_1.FormFieldTypes.MULTI_DROPDOWN:
                    return react_1.default.createElement(MultiDropdownForm_1.default, Object.assign({}, field));
                case form_field_types_1.FormFieldTypes.CHECKBOX_GROUP:
                    throw new Error('Checkbox Groups are not currently supported in v2 forms.');
                case form_field_types_1.FormFieldTypes.RADIO:
                    throw new Error('Radio Buttons are not currently supported in v2 forms.');
                case form_field_types_1.FormFieldTypes.AUTOCOMPLETE:
                    throw new Error('Not yet implemented autocomplete');
            }
        }
        else {
            throw new Error('Unable to Render!');
        }
    };
    const formFieldProps = field;
    if (formFieldProps.inputHeader) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            formFieldProps.inputHeader,
            getFormFieldComponent()));
    }
    else {
        return getFormFieldComponent();
    }
};
exports.default = FormFieldFromProps;
